import EmbedClocks from "./embed-clocks";

export default EmbedClocks;